var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTtsStop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 9,
    height: 12,
    rx: 2,
    fill: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.5C15.3 7.3 15.8 8.3 15.8 9C15.8 9.7 15.3 10.7 14.5 11.5",
    stroke: "#EF4444",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtsStop);
export default __webpack_public_path__ + "static/media/tts_stop.d86628a8c5b12f1d5dc7e357c7452c00.svg";
export { ForwardRef as ReactComponent };